import React, { Component } from 'react'
import '../App.css';
import './styles/MainScreen.css';
import firebase from '../firebase'

import MainScreenDesktop from './Desktop/MainScreen';
import MainScreenMobile from './Mobile/MainScreen';

export default class MainScreen extends Component {

  render() {

	if (this.props.isMobile) {
		// MOBILE VIEW
		return(
			<MainScreenMobile
				rightAction={this.props.rightAction}
				leftAction={this.props.leftAction}
				downAction={this.props.downAction}
				companyName={this.props.companyName}
				sloganText={this.props.sloganText} />
		)
	} else {
		// PC VIEW
		return (
			<MainScreenDesktop
				rightAction={this.props.rightAction}
				leftAction={this.props.leftAction}
				downAction={this.props.downAction}
				companyName={this.props.companyName}
				sloganText={this.props.sloganText} />
		)
	}

    
  }
}
